const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/AttachmentList/AttachmentList.tsx';
import React, { useEffect, useState } from 'react';
import { css, cx } from '@emotion/css';
import { downloadBase64PDF } from '@cistec/common_web/utils/pdf';
import { theme } from 'App/utils/clientSetupManager';
import LoadingSpinner from '@cistec/common_web/components/LoadingSpinner';
import { LoadPDFEndpoint } from 'App/actions/documents';
import { AppointmentAttachment } from 'App/store/appointmentAttachment';
import { LinkHrefTagFrame } from 'App/components/old_components/components/LinkFrame';

import { usePDF } from 'App/store/documents';

const cssInfo = css`
    color: ${theme.palette.primary.main};
`;

const cssWrapperStyle = css`
    display: flex;
    padding: ${theme.spacing(0.5)} 0;

    @media (max-width: ${theme?.breakpoints?.values?.sm}px) {
        padding: 0;
        margin-left: 0;
    }
`;
const cssContactStyle = css`
    margin-top: auto;
`;

const styleIcon: any = {
    color: theme.palette.primary.main,
};

interface SelectedPdf {
    endpoint: LoadPDFEndpoint;
    code: string;
    sender: string;
    filename: string | undefined;
}

interface Props {
    attachments: AppointmentAttachment[];
}

export const AttachmentList = (props: Props) => {
    const attachments = props.attachments;
    const [selectedPdf, setSelectedPdf] = useState<SelectedPdf>();

    const endpoint: LoadPDFEndpoint = selectedPdf?.endpoint ?? 'PatReports';
    const code = selectedPdf?.code ?? '';
    const sender = selectedPdf?.sender ?? '';

    const { data: pdfBase64, isPendingOrLoading: isLoading } = usePDF(endpoint, code, sender);

    useEffect(() => {
        if (pdfBase64 && selectedPdf?.filename) {
            downloadBase64PDF(pdfBase64, selectedPdf.filename);
            setSelectedPdf(undefined);
        }
    }, [pdfBase64, selectedPdf?.filename]);

    const attachmentJSX: any = [];

    const onClickPdf = (attachment: AppointmentAttachment): void => {
        const { sender, reportNr: code, filename, type: reportType } = attachment;
        const endpoint = reportType === 'KisPDF' ? 'Image' : 'PatReports';
        setSelectedPdf({ endpoint, code, sender, filename });
    };

    const getFilenameWithoutExtension = (filename: string) => {
        return filename.replace(/\.[^.]*$/, '');
    };
    attachments.forEach((attachment: AppointmentAttachment, ix: any): any => {
        attachmentJSX.push(
            <LinkHrefTagFrame
                key={`${attachment.terminNr};${ix}`}
                className={cx(cssInfo, cssWrapperStyle, cssContactStyle)}
                styleIcon={styleIcon}
                text={getFilenameWithoutExtension(attachment.filename)}
                iconName="icons8-document"
                onClick={() => onClickPdf(attachment)}
            />
        );
    });

    return (
        <>
            {attachments && (
                <>
                    {selectedPdf && isLoading && <LoadingSpinner center="absolute" />}
                    <div className={cx(cssInfo, cssWrapperStyle, cssContactStyle)} />
                    {attachmentJSX}
                </>
            )}
        </>
    );
};
